// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '5044179e-67ec-42ce-b34d-87c418a3a242',
      type: 'Container',
      name: 'starContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '0035c0dc-ee83-44f1-9299-e2c15b3be789',
      type: 'Sprite',
      name: 'bubble',
      className: '',
      x: 0,
      y: -26,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16641681,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Point_Bubble',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '1caf911d-f52c-4021-9d66-51ad6159c693',
      type: 'Container',
      name: 'fxContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '9829f329-7bc6-44cc-8f67-4218fd34c972',
      type: 'Sprite',
      name: 'star',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Animation_Star_1',
      parent: '5044179e-67ec-42ce-b34d-87c418a3a242'
    },
    {
      id: '705f25e0-79d7-4c9c-979b-1bbe2f8748dc',
      type: 'Sprite',
      name: 'starOverlay',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Animation_Star_1',
      parent: '5044179e-67ec-42ce-b34d-87c418a3a242'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  animations: [
    {
      id: 'd79eb526-3499-47d2-956e-b4c99f69381b',
      name: 'starAppearing',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: 'c1b3e424-ea92-4774-a2b5-3af10715d2dc',
          type: 'Tween',
          name: 'starScale',
          duration: 900,
          track: 1,
          target: {
            scale: {
              x: 1,
              y: 1
            },
            y: -30
          },
          startAt: 0,
          sourceName: 'starContainer',
          easing: 'ElasticOut',
          disabled: false
        },
        {
          id: '1b20fa2d-9d9b-414c-9321-a353ea6eeac2',
          type: 'Tween',
          name: 'starOverlayAlpha',
          duration: 300,
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 96,
          sourceName: 'starOverlay',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: 'c96e3013-8f6c-4cbb-8da8-d9f5cf1382ae',
          type: 'Tween',
          name: 'bubbleScale',
          duration: 500,
          track: 4,
          target: {
            scale: {
              x: 1.6,
              y: 1.6
            }
          },
          startAt: 313,
          sourceName: 'bubble',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '0f75d369-df9b-4e71-af39-ba76cee7df0e',
          type: 'Tween',
          name: 'starOverlayAlpha_copy',
          duration: 300,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 397,
          sourceName: 'starOverlay',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '2c57ded8-3371-4512-8cf5-e5c73a403f1f',
          type: 'Tween',
          name: 'bubbleAlpha',
          duration: 250,
          track: 3,
          target: {
            scale: {},
            alpha: 0
          },
          startAt: 559,
          sourceName: 'bubble',
          easing: 'CubicOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class StarTaskBubbleLayout {
  static raw = raw;
  root!: Container;
  starContainer!: Container;
  bubble!: Sprite;
  fxContainer!: Container;
  star!: Sprite;
  starOverlay!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class starAppearing {
  Layout: {
    starContainer: object;
    starOverlay: object;
    bubble: object;
  };

  BlockTypeByName: {
    starScale: object;
    starOverlayAlpha: object;
    bubbleScale: object;
    starOverlayAlpha_copy: object;
    bubbleAlpha: object;
  };

  flowData = raw.animations[0];
}
